import DatePickerInput from '../inputs/DatePickerInput';
import createField from './createField';

const DatePickerField = createField(DatePickerInput);

export default DatePickerField;
